import { AxiosResponse } from 'axios'
import clientApi from '../../api/clientApi'
import {
  HospitalDoctor,
  HospitalSynchronizedAt,
  ManagedHospital,
  NewHospitalDoctor,
  UpdateHospitalDoctor,
} from './types'

const apiEndpoint = process.env.REACT_APP_REPASSE_API_ENDPOINT

export const getManagedHospitals = async (): Promise<ManagedHospital[]> => {
  const { data } = await clientApi.get<ManagedHospital[]>(
    `${apiEndpoint}/hospitals/admins/managed-hospitals`
  )

  return data
}

export const getHospitalSynchronizedAt = async (
  hospitalId: number
): Promise<HospitalSynchronizedAt> => {
  const { data } = await clientApi.get<HospitalSynchronizedAt>(
    `${apiEndpoint}/hospitals/${hospitalId}/sincronized-at`
  )

  return data
}

export const getDoctors = async (
  hospitalId: number
): Promise<HospitalDoctor[]> => {
  const { data } = await clientApi.get<HospitalDoctor[]>(
    `${apiEndpoint}/doctors/hospital/${hospitalId}`
  )

  return data
}

export const addDoctor = async (
  hospitalId: number,
  hospital: NewHospitalDoctor
): Promise<HospitalDoctor> => {
  const { data } = await clientApi.post<
    NewHospitalDoctor,
    AxiosResponse<HospitalDoctor>
  >(`${apiEndpoint}/doctors/hospital/${hospitalId}`, hospital)

  return data
}

export const updateDoctor = async (
  hospitalId: number,
  doctorId: number,
  doctor: UpdateHospitalDoctor
): Promise<HospitalDoctor> => {
  const { data } = await clientApi.patch<
    UpdateHospitalDoctor,
    AxiosResponse<HospitalDoctor>
  >(`${apiEndpoint}/doctors/hospital/${hospitalId}/${doctorId}`, doctor)

  return data
}

export const sendCreatePasswordEmail = async (
  doctorId: number
): Promise<void> => {
  await clientApi.post(
    `${apiEndpoint}/doctors/hospital/${doctorId}/send-create-password-email`
  )
}
